import { Material, Mesh, Object3D } from 'three';

import { isDefined } from '../variables';

export function getMaterials(node: Object3D): Material[] {
  const material = (node as Mesh | undefined)?.material;

  return Array.isArray(material) ? material : isDefined(material) ? [material] : [];
}

export function cloneMaterials(node: Object3D) {
  const material = (node as Mesh | undefined)?.material;

  const materials = Array.isArray(material) ? material : isDefined(material) ? [material] : [];

  const clonedMaterials = materials.map((x) => x.clone());

  if (clonedMaterials.length === 1) {
    (node as Mesh).material = clonedMaterials[0];
  } else if (clonedMaterials.length > 0) {
    (node as Mesh).material = clonedMaterials;
  }
}
